const Constants = {
  TOKEN_NAME: "x-auth",
  PRICE_RANGE: { min: 2000, max: 100000 },
  SEARCH_MIN_RADIUS: 50,
  SEARCH_MAX_RADIUS: 500,
  MAX_FILES: 5,
  ARTWORK_MIN_PRICE: 2000,
  BIDDING_STARTS_MIN_DAYS_AHEAD: 7,
  // Seller SLA — start shipping within this many business days of payment.
  // Display-only (copy/tooltips); the API is the source of truth for the
  // actual deadline date. Keep in sync with api SHIPMENT_DEADLINE_BUSINESS_DAYS.
  SHIPMENT_DEADLINE_BUSINESS_DAYS: 5,
  RADIUS: 8,
  PAGINATION_SIZE: 10,
  PHONE_NUMBER_LENGTH: 9,
  IMG_COMPRESSION_QUALITY: 0.8,
  THUMBNAIL_SIZE: 700,
  LOADER_DURATION: 1300,
  GRID_PADDING: 4,
  CHART_HEIGHT: 300,
  BIG_NUMBER: 1000000000000,
  LINE_CHART_OPTIONS: {
    borderColor: "rgb(0, 0, 0)",
    backgroundColor: "rgb(0, 0, 0)",
    fill: true,
    smooth: true,
    responsive: true,
    maintainAspectRatio: false,
    pointBackgroundColor: "#fff",
    radius: 3,
    scales: {
      y: {
        min: 0,
      },
      x: {
        min: 0,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      filler: {
        propagate: true,
      },
    },
  },
  BAR_CHART_OPTIONS: {
    borderColor: "rgb(0, 0, 0)",
    backgroundColor: "rgb(0, 0, 0)",
    responsive: true,
    maintainAspectRatio: false,
    borderRadius: 0,
    barThicknesss: 10,
    maxBarThickness: 10,
    plugins: {
      legend: {
        display: false,
      },
    },
  },
  PIE_CHART_OPTIONS: {
    // https://www.chartjs.org/docs/latest/charts/doughnut.html
    circumference: 360,
    animation: { animateScale: true, animateRotate: false },
    spacing: 3,
    borderRadius: 0,
    borderWidth: 0,
    offset: 0,
    rotation: 0,
    weight: 0,
    cutout: "60%",
    plugins: {
      legend: {
        display: false,
      },
      colors: {
        enabled: true,
      },
    },
  },
  PIE_CHART_COLORS: [
    "#1DDFA3",
    "#23ABD8",
    "#4C6EDB",
    "#52F667",
    "#6E40AA",
    "#AFF05B",
    "#BF3CAF",
    "#E2B72F",
    "#FE4B83",
    "#FF7847",
  ],
};

export default Constants;
